
import { PaymentsChart } from "@/components/admin/PaymentsChart";
import { BarChart3, Calendar } from "lucide-react";

interface ChartSectionProps {
  payments: any[] | undefined;
}

export const ChartSection = ({ payments }: ChartSectionProps) => {
  return (
    <div className="glass-card rounded-xl border border-primary/10 overflow-hidden">
      <div className="p-4 sm:p-6 border-b border-primary/10">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-primary/10">
              <BarChart3 className="h-5 w-5 text-primary" />
            </div>
            <h3 className="text-lg font-semibold text-primary">Pagos por mes</h3>
          </div>
          
          <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-primary/5 text-primary/60 border border-primary/10">
            <Calendar className="h-3 w-3" />
            Último año
          </span>
        </div>
      </div>
      
      <div className="p-4 sm:p-6">
        <div className="h-[300px]">
          <PaymentsChart payments={payments || []} />
        </div>
      </div>
    </div>
  );
};
